'use client';

import { useEffect } from 'react';
import Console from './initialize.console';
export const Initialize = () => {
  useEffect(() => {
    console.log(Console);
  }, []);
  return null;
};